/* eslint-disable no-param-reassign */
import { FETCH_STATUSES } from '../../../utils/fetchStatusUtils';

const loadResourceSlice = (options) => {
  const { resource, repository } = options;

  return {
    initialState: {
      [resource]: {
        loadingStatus: FETCH_STATUSES.idle,
        item: null,
        error: null,
      },
    },

    reducers: {
      loadResourceStart(state) {
        state[resource].loadingStatus = FETCH_STATUSES.pending;
        state[resource].item = null;
        state[resource].errors = null;
      },
      loadResourceSuccess(state, { payload: { item } }) {
        state[resource].loadingStatus = FETCH_STATUSES.fulfilled;
        state[resource].item = item;
      },
      loadResourceFail(state, { payload: { errors } }) {
        state[resource].loadingStatus = FETCH_STATUSES.failed;
        state[resource].errors = errors;
      },
      loadResourceReset(state) {
        state[resource].loadingStatus = FETCH_STATUSES.idle;
        state[resource].item = null;
        state[resource].errors = null;
      },
    },

    actionCreators(restDispatch) {
      return {
        loadResource: async (params) => {
          try {
            restDispatch('loadResourceStart');
            const result = await repository.show(params);
            const { data } = result;
            const successParams = {
              item: data[resource],
            };
            restDispatch('loadResourceSuccess', successParams);
          } catch (errors) {
            const { response } = errors;
            const { data } = response;
            restDispatch('loadResourceFail', data);
            throw errors;
          }
        },
        loadResetResource: () => restDispatch('loadResourceReset'),
      };
    },
  };
};

export default loadResourceSlice;
